import { DateTime } from 'luxon';
import { DriverLogsState } from '../types';

export const driverLogsState: DriverLogsState = {
  /**
   * -------------------------------------
   * State for toggling a modal
   * -------------------------------------
   */
  // Modals in the driver information's section
  isToggleRecapModal: false,
  isToggleDriverLogFormModal: false,
  // Modals in the data-table section
  isToggleMultipleEditModal: false,
  isToggleUploadDriverLogEditModal: false,
  isToggleAddShipmentModal: false,
  isToggleDrivingExceptionsModal: false,
  isToggleCreateUpdateStatusModal: false,
  isToggleCreateUpdateRemarksModal: false,
  isToggleDeleteRemarksModal: false,
  isToggleReassignDriveTimeModal: false,
  isToggleDrivingViolationDetailsModal: false,
  // Related to Canadian region
  isToggleChangeCycleModal: false,
  isToggleChangeStartTimeModal: false,
  isToggleAdditionalHoursModal: false,
  // Modal in the header section
  isToggleExportFileModal: false,
  isToggleDriverDailyDocumentsModal: false,
  /**
   * -------------------------------------
   * State for `Show All/Edits` checkboxes
   * -------------------------------------
   */
  isShowAll: false,
  isShowEdits: false,
  /**
   * -------------------------------------
   * State for toggling the driver's timezone
   * -------------------------------------
   */
  isToggleDriversTimezone: false,
  isToggleGridViewEditForm: false,
  /**
   * -------------------------------------
   * State for API request status
   * -------------------------------------
   */
  isInitializeFileExportRequestPending: false,
  isInitializingFetchDataRequestPending: false, // This is the state of an API request to display the data in the Logs page.
  /**
   * -------------------------------------
   * State for the data source
   * -------------------------------------
   */
  selectedDate: DateTime.local().toISODate() as string,
  selectedDriver: null,
  // Data sources
  driver: null,
  equipments: [],
  driverCalcs: [],
  driverDailies: [],
  driverHistories: [],
  userPreferences: [],
  driverHistoryLogToEdit: null,
  documentType: 'pdf',
  refetchDataCount: 0,
  accountProperties: [],
  decoratedDriver: null,
  decoratedDriverHistories: [],
};
